<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 20 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="black" height="21" width="20" y="3"/>
    <rect fill="#18BDE8" height="3" width="20"/>
    <path d="M13.7085 8V9.74429H8.11424V12.4314H13.4728V14.1914H8.11424V17.2557H13.9442V19H6.05566V8H13.7085Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'EyeAppealE',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
  },
};

</script>
